// requisições
import { getCompetitionProposals, downloadComercialProposal } from '@/services';
import { getPublicDocuments } from '@/services/api/supplier';
// componentes
import RequestPublicDocuments from '@/components/contractor/competitions/proposals/modals/request-public-documents';
import PublicDocuments from '@/components/contractor/competitions/proposals/modals/public-documents';
export default {
    name: 'Table',
    data: () => ({
        modalRequestPublicDocuments: false,
        modalAttachments: false,
        noComercialProposal: false,
        modalPublicDocuments: false,
        suppliersWithEnabledProposals: [],
        suppliersWithEnabledInvitations: [],
        suppliersWithDisabledProposals: [],
        suppliersWithDisabledInvitations: [],
        attachments: [],
        checkbox: {
            allEnable: false,
            allDisable: false,
            proposals: [],
            supplier: []
        },
        supplierAccount: {},
        documents: []
    }),
    components: { RequestPublicDocuments, PublicDocuments },
    props: {
        id: {
            type: String,
            default: '8'
        },
        competitionData: Object
    },
    methods: {
        checkboxSelected(target, type1, type2) {
            this[target] = !this[target];
            if (this[target]) {
                const proposals = this[type1].map(({ id }) => {
                    return id;
                });
                const invitations = this[type2];
                // .map(({ token }) => {
                // 	return token;
                // });
                this.checkbox.proposals = this.checkbox.proposals.concat(proposals);
                this.checkbox.supplier = this.checkbox.supplier.concat(invitations);
            } else {
                this.checkbox.proposals.forEach((id, index) => {
                    this[type1].forEach(obj => {
                        if (id == obj.id) {
                            this.checkbox.proposals.splice(index, 1);
                        }
                    });
                });
                this.checkbox.supplier.forEach(({ token }, index) => {
                    this[type2].forEach(obj => {
                        if (token == obj.token) {
                            this.checkbox.supplier.splice(index, 1);
                        }
                    });
                });
            }
            this.$emit('toggle-proposals', this.checkbox.proposals);
            this.$emit('toggle-invitations', this.checkbox.supplier);

            console.log(this.checkbox.proposals);
            console.log(this.checkbox.supplier);
        },
        async downloadComercialProposal({ id }) {
            const data = await downloadComercialProposal(id);
            const newWindow = window.open('', '_blank');
            newWindow.blur();
            if (data.attachments.length > 0) {
                if (data.attachments.length == 1) {
                    if (data.comercialProposal != '') {
                        newWindow.location.href = data.attachments[0].url;
                    } else {
                        this.noComercialProposal = true;
                        newWindow.close();
                    }
                } else {
                    newWindow.close();
                    this.modalAttachments = true;
                    this.attachments = data.attachments;
                }
            } else {
                newWindow.close();
                this.noComercialProposal = true;
            }
        },
        async publicDocuments({ supplier }) {
            this.supplierAccount = supplier;
            try {
                const { publicDocuments } = await getPublicDocuments(supplier.id);
                console.log(publicDocuments);
                if (!publicDocuments.length) {
                    this.modalRequestPublicDocuments = true;
                } else {
                    this.documents = publicDocuments;
                    this.modalPublicDocuments = true;
                }
            } catch (e) {
                console.error(e);
            }
        }
    },
    async created() {
        const data = await getCompetitionProposals(this.id);
        this.suppliersWithEnabledProposals = data.enabledProposals;
        this.suppliersWithEnabledInvitations = data.enabledInvitations;
        this.suppliersWithDisabledProposals = data.disabledProposals;
        this.suppliersWithDisabledInvitations = data.disabledInvitations;
        // console.log(data);
    }
};
